import store from '../store'

import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'

// Products
import ProductList from '../components/Products/List.vue'
import ProductEdit from '../components/Products/Edit.vue'
import ProductCreate from '../components/Products/Create.vue'
// Customer
import CustomerEdit from '../components/Customers/CustomerDetail.vue'
import CustomerSearch from '../components/Customers/Search.vue'
import CustomerCreate from '../components/Customers/Create.vue'
// Orders
import OrderList from '../components/Orders/List.vue'
import OrderEdit from '../components/Orders/Edit.vue'
import OrderCreate from '../components/Orders/Create.vue'

// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'
import Transactions from 'src/components/Dashboard/Views/Dashboard/Transactions.vue'
// Classrooms
import ClassroomList from '../components/Classrooms/List.vue'
import ClassroomManage from '../components/Classrooms/Manage.vue'
import ClassroomCreate from '../components/Classrooms/Create.vue'
import ClassroomEdit from '../components/Classrooms/Edit.vue'
import TutorList from '../components/Classrooms/Tutors.vue'
import VenueList from '../components/Classrooms/Venues.vue'
import VenueEdit from '../components/Classrooms/VenueEdit.vue'
import ClassroomInvoice from '../components/Classrooms/Invoice.vue'
import ClassroomSearch from '../components/Classrooms/Search.vue'

// Tutors
import TutorInvoices from '../components/Tutor/Invoices.vue'
import TutorClasses from '../components/Tutor/Classes.vue'
import TutorRegister from '../components/Tutor/Register.vue'
import TutorOnlineRegister from '../components/Tutor/RegisterOnline.vue'
import TutorFeedback from '../components/Tutor/Feedback.vue'
import TutorEdit from '../components/Tutor/TutorEdit.vue'
import TutorInvoice from '../components/Tutor/Invoice.vue'
import GenerateInvoice from '../components/Tutor/Generate.vue'
import GenerateLetter from '../components/Tutor/Lor.vue'
import GenerateOnlineLetter from '../components/Tutor/LorOnline.vue'
import SelectClassrooms from '../components/Tutor/SelectClassrooms.vue'

// Reports
import BalancePayments from '../components/Reports/BalancePayments.vue'
import Enrollments from '../components/Reports/Enrollments.vue'
import Sales from '../components/Reports/SalesVat.vue'
import SalesTrans from '../components/Reports/SalesTransactions.vue'
import CertsSent from '../components/Reports/CertsSent.vue'
import Partners from '../components/Reports/Partners.vue'
import Flexibles from '../components/Reports/Flexibles.vue'
import Frequent from '../components/Reports/frequentlyBought.vue'
import Advanced from '../components/Reports/Advanced.vue'


// Pages
import User from 'src/components/User/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Login/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'
// Subscribe
// import Subscribe from 'src/components/Subscribe/index.vue'

// Certificates
import CertificatesList from '../components/Certificates/List.vue'
import CertificatesPrint from '../components/Certificates/Print.vue'

// Promotions
import PromotionsList from '../components/Promotions/list.vue'
import PromotionsEdit from '../components/Promotions/edit.vue'

// Mailchimp
import MailchimpList from '../components/Mailchimp/List.vue'
import MailchimpDetail from '../components/Mailchimp/Detail.vue'
import CampaignsList from '../components/Mailchimp/Campaigns.vue'
import AutomationsList from '../components/Mailchimp/Automations.vue'
import StoresList from '../components/Mailchimp/Store.vue'
import ProductsList from '../components/Mailchimp/Products.vue'
// Finance
import SalesList from '../components/Finance/Sales.vue'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}
const notTutor= (to, from, next) => {
  if (store.getters.getRole=="tutor" || store.getters.getRole=="" ) {  console.log("Not Tutor >>>"+ store.getters.getRole)
    next( '/tutors')
    return 

  }else{
    next()
    return false
  }
  
}
let mailchimpMenu = {
  path: '/mailchimp',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  beforeEnter: ifAuthenticated && notTutor,
  children: [
    {
      path: 'list',
      name: 'Members List',
      component: MailchimpList
    },
    {
      path: 'edit/:id',
      name: 'Members Detail',
      component: MailchimpDetail
    },
    {
      path: 'campaigns',
      name: 'Members Detail',
      component: CampaignsList}
      ,
    {
      path: 'automations',
      name: 'Automations Detail',
      component: AutomationsList}
      ,
    {
      path: 'ecommerce',
      name: 'Stores',
      component: StoresList}
      ,
      {
        path: 'ecommerce/store/:id',
        name: 'Products',
        component: ProductsList
      }
  ]
}
let productMenu = {
  path: '/product',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  beforeEnter: ifAuthenticated && notTutor,
  children: [

    {
      path: 'list',
      name: 'Products',
      component: ProductList
    },
    {
      path: 'edit/:id',
      name: 'Edit Product',
      component: ProductEdit
    },
    {
      path: 'Create',
      name: 'Create Product',
      component: ProductCreate
    }
  ]
}

let customerMenu = {
  path: '/customer',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  beforeEnter: ifAuthenticated && notTutor,
  children: [

    {
      path: 'edit/:id',
      name: 'Edit Customer',
      component: CustomerEdit
    },

    {
      path: ':property/:value',
      name: 'Find Customer',
      component: CustomerSearch,
      props: true
    },
    {
      path: 'create',
      name: 'Customer Create',
      component: CustomerCreate,
      props: true
    },
    {
      path: 'list',
      name: 'Customer List',
      component: CustomerSearch
    }

  ]
}

let orderMenu = {
  path: '/order',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated && notTutor,
  children: [

    {
      path: 'list',
      name: 'Orders',
      component: OrderList
    },
    {
      path: 'transaction/:transaction',
      name: 'Order By Transaction',
      component: OrderList
    },
    {
      path: 'edit/:id',
      name: 'Order Edit',
      component: OrderEdit
    },
    {
      path: 'id/:id',
      name: 'Edit Search',
      component: OrderEdit
    },
    {
      path: 'create',
      name: 'Order Create',
      component: OrderCreate
    }

  ]
}

let classroomMenu = {
  path: '/classroom',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  beforeEnter: ifAuthenticated && notTutor,
  children: [

    {
      path: 'list',
      name: 'Classrooms',
      component: ClassroomList
    },
    {
      path: 'manage',
      name: 'Manage Classrooms',
      component: ClassroomManage
    },
    {
      path: 'create',
      name: 'Create Classroom',
      component: ClassroomCreate
    },
    {
      path: 'edit/:id',
      name: 'Edit Classroom',
      component: ClassroomEdit
    },

    {
      path: 'tutors',
      name: 'Tutors',
      component: TutorList
    },

    {
      path: 'venues',
      name: 'Venues',
      component: VenueList
    },

    {
      path: 'venue/edit/:id',
      name: 'Venue Edit',
      component: VenueEdit
    },

    {
      path: 'invoices/',
      name: 'Create Invoice',
      component: ClassroomInvoice
    },
    {
      path: ':property/:value',
      name: 'Find Classroom',
      component: ClassroomSearch,
      props: true
    },
  ]
}

let tutorMenu = {
  path: '/tutors',
  name: 'tutors',
  component: DashboardLayout,
  redirect: '/tutors/dashboard',
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: 'invoices',
      name: 'Tutor Invoices',
      component: TutorInvoices
    },
    {
      path: 'dashboard',
      name: 'Tutor Dashboard',
      component: TutorClasses
    },
    {
      path: 'classes',
      name: 'Manage Classes',
      component: SelectClassrooms
    },
    {
      path: 'register/:id',
      name: 'Class Register',
      component: TutorRegister
    },
    {
      path: 'register-online/:id',
      name: 'Class Register',
      component: TutorOnlineRegister
    },
    {
      path: 'feedback/:id',
      name: 'Class Feedback',
      component: TutorFeedback
    },

    {
      path: 'invoice/:id',
      name: 'Create/Edit Invoice',
      component: TutorInvoice
    },

    {
      path: 'generate/:id',
      name: 'Generate Invoice',
      component: GenerateInvoice
    },

    {
      path: 'edit/:id',
      name: 'Edit',
      component: TutorEdit
    },
    

    {
      path: 'lor/:id',
      name: 'Edit LOR',
      component: GenerateLetter
    },
    {
      path: 'lor-online/:id',
      name: 'Edit LOR',
      component: GenerateOnlineLetter
    }
  ]

}
let certificatesMenu = {
  path: '/certificates',
  name: 'certificates',
  component: DashboardLayout,
  redirect: '/tutor',
  beforeEnter: ifAuthenticated && notTutor,
  children: [
    {
      path: 'list',
      name: 'Certificates',
      component: CertificatesList
    },
    {
      path: 'print',
      name: 'Certificates Print',
      component: CertificatesPrint
    }
  ]

}

let promotionsMenu = {
  path: '/promotions',
  name: 'promotions',
  component: DashboardLayout,
  redirect: '/promotions',
  beforeEnter: ifAuthenticated && notTutor,
  children: [
    {
      path: 'list',
      name: 'Promotions',
      component: PromotionsList
    },
    {
      path: 'edit/:id',
      name: 'Edit Promotion',
      component: PromotionsEdit
    },
    {
      path: ':property/:value',
      name: 'Find Promotion',
      component: PromotionsList,
      props: true
    }
  ]

}

let reportsMenu = {
  path: '/reports',
  name: 'reports',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated && notTutor,
  children: [
    {
      path: 'balances',
      name: 'Balance Payments',
      component: BalancePayments
    },
    {
      path: 'partners',
      name: 'Partner Enrollments',
      component: Partners
    },
    
    {
      path: 'flexibles',
      name: 'Flexible Classroom',
      component: Flexibles
    },
    {
      path: 'sales',
      name: 'Sales',
      component: Sales
    },
    {
      path: 'salestrans',
      name: 'Sales Transactions',
      component: SalesTrans
    },

    {
      path: 'certsent',
      name: 'Certs',
      component: CertsSent
    }
    ,
 
    {
      path: 'frequently',
      name: 'Frequently Bought Together',
      component: Frequent
    }
    ,
 
    {
      path: 'advanced',
      name: 'Advanced Course Purchases',
      component: Advanced
    }
  ]

}
let financeMenu = {
  path: '/finance',
  name: 'finance',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated && notTutor,
  children: [
    {
      path: 'sales',
      name: 'Sales Figures',
      component: SalesList
    }
  ]

}
let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  beforeEnter: ifAuthenticated ,
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
  beforeEnter: ifNotAuthenticated
}
let tutorLogin = {
  path: '/tutor',
  name: 'Login',
  component: Login,
  beforeEnter: ifNotAuthenticated
}
/*
let subscribePage={
  path: '/subscribe',
  name:'subscribe',
  component: Subscribe
}
*/
let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: DashboardLayout,
    beforeEnter: ifNotAuthenticated && notTutor,
    redirect: '/home/',
    children: [

    ]
  },

  productMenu,
  orderMenu,
  customerMenu,
  classroomMenu,
  tutorMenu,
  certificatesMenu,
  mailchimpMenu,
  // componentsMenu,
  // formsMenu,
  // tablesMenu,
  // mapsMenu,
  reportsMenu,
  promotionsMenu,
  pagesMenu,
  financeMenu,
  loginPage,
  tutorLogin,
  // subscribePage,
  registerPage,
  lockPage,
  {
    path: '/home',
    component: DashboardLayout,
    redirect: '/home/transactions',
    beforeEnter: ifAuthenticated && notTutor,
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'stats',
        name: 'Stats',
        beforeEnter: ifAuthenticated && notTutor,
        component: Stats
      },
      {
        path: 'transactions',
        name: 'Transactions',
        beforeEnter: ifAuthenticated && notTutor,
        component: Transactions
      }
    ]
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js